/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterStorageAccountRequest
 */
export interface RegisterStorageAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    azureStorageAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    azureEntraTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    servicePrincipalClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    servicePrincipalClientSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterStorageAccountRequest
     */
    region?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterStorageAccountRequest
     */
    complianceAttestationAccepted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterStorageAccountRequest
     */
    validateOnCreate?: boolean;
}

/**
 * Check if a given object implements the RegisterStorageAccountRequest interface.
 */
export function instanceOfRegisterStorageAccountRequest(value: object): value is RegisterStorageAccountRequest {
    return true;
}

export function RegisterStorageAccountRequestFromJSON(json: any): RegisterStorageAccountRequest {
    return RegisterStorageAccountRequestFromJSONTyped(json, false);
}

export function RegisterStorageAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterStorageAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'azureStorageAccountName': json['azureStorageAccountName'] == null ? undefined : json['azureStorageAccountName'],
        'azureEntraTenantId': json['azureEntraTenantId'] == null ? undefined : json['azureEntraTenantId'],
        'servicePrincipalClientId': json['servicePrincipalClientId'] == null ? undefined : json['servicePrincipalClientId'],
        'servicePrincipalClientSecret': json['servicePrincipalClientSecret'] == null ? undefined : json['servicePrincipalClientSecret'],
        'region': json['region'] == null ? undefined : json['region'],
        'complianceAttestationAccepted': json['complianceAttestationAccepted'] == null ? undefined : json['complianceAttestationAccepted'],
        'validateOnCreate': json['validateOnCreate'] == null ? undefined : json['validateOnCreate'],
    };
}

export function RegisterStorageAccountRequestToJSON(json: any): RegisterStorageAccountRequest {
    return RegisterStorageAccountRequestToJSONTyped(json, false);
}

export function RegisterStorageAccountRequestToJSONTyped(value?: RegisterStorageAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'azureStorageAccountName': value['azureStorageAccountName'],
        'azureEntraTenantId': value['azureEntraTenantId'],
        'servicePrincipalClientId': value['servicePrincipalClientId'],
        'servicePrincipalClientSecret': value['servicePrincipalClientSecret'],
        'region': value['region'],
        'complianceAttestationAccepted': value['complianceAttestationAccepted'],
        'validateOnCreate': value['validateOnCreate'],
    };
}

